<template>
  <a
    v-if="showVoidFlg"
    style="color: #ff4d4f"
    href="javascript:void(0);"
    size="small"
    :loading="loading"
    :class="className"
    type="link"
    danger
    @click="showDialog"
  >
    作废
  </a>

  <a-modal :confirmLoading="loading" v-model:visible="visible" title="输入作废原因" @ok="handleOk">
    <div class="approval-dialog__subtitle">（必填）</div>
    <a-textarea
      show-count
      v-model:value="approvalContent"
      placeholder="请输入作废原因，最多200字"
      :auto-size="{ minRows: 3 }"
      :maxlength="200"
      allowClear
    />
  </a-modal>
</template>

<script>
import { defineComponent, reactive, toRefs, computed } from "vue";
import { ApprovalFlowService } from "../approval-flow.service";
import { message } from "ant-design-vue";
import { number } from "echarts";
import { useStore } from "@/store";
export default defineComponent({
  name: "submit-approval-btn",
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    bizName: {
      type: String,
      required: true,
    },
    flg: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    access: {
      type: String,
    },
    className: {
      type: String,
    },
  },
  emits: ["refresh", "update:loading"],
  setup(props, { emit }) {
    const store = useStore();
    const state = reactive({
      visible: false,
      approvalContent: "",
    });
    const showDialog = () => {
      state.approvalContent = "";
      state.visible = true;
    };
    const { run, loading } = ApprovalFlowService.useVoidApi();
    const handleOk = async () => {
      if (!state.approvalContent) {
        message.warning("请填写作废原因");
        return;
      }
      try {
        emit("update:loading", true);
        const { bizId, bizType, bizName } = props;
        const data = {
          bizId,
          bizType,
          bizName,
          remark: state.approvalContent,
        };
        let res = await run(data);
        if (res.respCode !== "0000") {
          // message.error(res.respDesc);
          return;
        }
        message.success(res.respDesc);
        emit("refresh", null);
        state.visible = false;
      } finally {
        emit("update:loading", false);
      }
    };
    const showVoidFlg = computed(() => {
      let t = store.state.user.buttons[props.access || ""];
      return t && props.flg;
    });
    return {
      ...toRefs(state),
      showDialog,
      handleOk,
      loading,
      showVoidFlg,
    };
  },
});
</script>

<style scoped>
.approval-dialog__subtitle {
  color: #6d6d6d;
  position: absolute;
  top: 16px;
  left: 128px;
  font-size: 14px;
}
</style>
